import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
// import { Link } from 'react-router-dom';

// components
import Grid from '@material-ui/core/Grid';
// import Breadcrumbs from '@material-ui/core/Breadcrumbs';
// import Container from '@material-ui/core/Container';
// import Modal from '@material-ui/core/Modal';
// import AddEditEvent from './components/AddEditEvent';
import Typography from 'components/shared/Typography';
// import LoadingButton from 'components/shared/LoadingButton';
// import Calendar from './components/Calendar';
// import CircularProgress from '@material-ui/core/CircularProgress';
import { SPACING_THIRD, SPACING, SPACING_HALF, SPACING_LEAST } from 'constants/spacing';
import RectangularGrid from 'components/shared/RectangularGrid';
import { Link } from '@material-ui/core';
import LoadingButton from 'components/shared/LoadingButton';
import SelectServiceComponent from 'components/shared/SelectServiceByCustomer';
import SelectDivision from 'components/shared/SelectDivisionByCustomer';

// hooks
// import { useAllEvents, useCreateEvent, useUpdateEvent } from 'hooks/event';
// import { useDivisionValue } from 'providers/DivisionProvider';

// utils
// import { arrayUniqueKey } from 'utils';

//assets
import selectServiceImage from 'assets/images/customer/service.png';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    // minHeight: '100vh',
    minHeight: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  leftPanel: {
    width: '100%',
    // minHeight: '100vh',
    minHeight: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  form: {
    width: '100%',
  },
  buttonWraper: {
    marginTop: theme.spacing(SPACING),
    bottom: '0',
    position: 'relative',
  },
  monkey: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  phoneInput: {
    '& .MuiInputBase-input::placeholder': {
      textAlign: 'center',
    },
    '& .MuiInputBase-input': {
      textAlign: 'right',
      direction: 'rtl',
    },
  },
  largeLabel: {
    // marginTop: 15,
    fontSize: theme.typography.pxToRem(20),
    // borderColor: '',
    // height: '75%',
    '&:disabled':{
      color: '#959595'
    }
  },
  backButton: {
    backgroundColor: 'transparent',
    color: '#878787',
    border: '1px solid',
    borderColor: '#878787',
    '&:hover':{
      backgroundColor: 'transparent',
      color:"#333",
      borderColor: '#333',
    }
  },
  wholepage: {
    width: '100vw',
    height: '100vh',
    backgroundColor: '#e5e5e5',
  },
  mainContainer: {
    backgroundColor: '#f5f5f5',
    // borderRadius:"10px",
    position: 'relative',
    top: '15%',
    padding: '0px',

    [theme.breakpoints.down('xs')]: {
      backgroundColor: '#e5e5e5',
      top: '0',
    },
  },

  checkbox: {
    position: 'relative',
    top: '35%',
    width: '50%',
  },
  singleLineText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

function SelectService({
  selectedBranch,
  selectedService,
  setSelectedService,
  nextStep,
  prevStep,
}) {
  const classes = useStyles();

  const [selectedDivision, setSelectedDivision] = useState('');
  // const [selectedService, setSelectedSevice] = useState('');

  const onSubmitNext = (e) => {
    console.log('nwx!1:', e);
    nextStep();
  };

  const onSubmitPrev = (e) => {
    console.log('back!!!:', e);
    prevStep();
  };
  return (
    <Grid container spacing={0} style={{ height: '100%', overflowX: 'hide' }}>
      <Grid item xs={12} md={6} style={{ height: '100%', padding: '3%', overflowY: 'auto' }}>
        <Grid container style={{ alignContent: 'space-between', height: '100%' }}>
          <Grid item xs={12}>
            <Grid container spacing={SPACING_HALF}>
              <Grid
                item
                xs={12}
                style={{ alignContent: 'center', textAlign: 'center', marginTop: '3%' }}
              >
                <Typography variant="h1">انتخاب سرویس</Typography>
              </Grid>
              <Grid item xs={12} style={{ alignContent: 'center', textAlign: 'center' }}>
                <Typography variant="h5" style={{ color: '#838383' }}>
                  لطفا سرویس مورد نظر خود را جهت استفاده انتخاب نمایید
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                style={{ alignContent: 'center', textAlign: 'center', marginTop: '3%' }}
              >
                <Grid container spacing={SPACING_LEAST}>
                  <Grid item xs={12}>
                    <SelectDivision
                      value={selectedDivision}
                      setSelectedDivision={setSelectedDivision}
                      setSelectedService={setSelectedService}
                      selectedBranch={selectedBranch}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <SelectServiceComponent
                      divisionId={selectedDivision?._id}
                      selectedService={selectedService}
                      setSelectedService={setSelectedService}
                    ></SelectServiceComponent>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={SPACING_HALF} style={{ bottom: 0, position: 'relative' }}>
              <Grid item xs={6} className={classes.buttonWraper}>
                <LoadingButton
                  className={classes.largeLabel}
                  type="submit"
                  // size="small"
                  fullWidth
                  variant="contained"
                  color="primary"
                  disabled={selectedService === ''}
                  onClick={onSubmitNext}
                >
                  ثبت
                </LoadingButton>
              </Grid>
              <Grid item xs={6} className={classes.buttonWraper}>
                <LoadingButton
                  className={clsx(classes.largeLabel, classes.backButton)}
                  type="submit"
                  // size="small"
                  fullWidth
                  variant="contained"
                  // color="default"
                  // disabled={selectedService === ''}
                  onClick={onSubmitPrev}
                >
                  بازگشت
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6} className={classes.leftPanel}>
        <img src={selectServiceImage} alt="left" height={'70%'} />
      </Grid>
    </Grid>
  );
}

export default SelectService;
